import { Routes, Route } from "react-router-dom";
import Acceuil from "../pages/Home";
import Osint from "../pages/osint";
import Pentest from "../pages/pentest";
import ContactPage from "../pages/contact";
import RdvPage from "../pages/rdv";
import ResourcesPage from "../pages/resources";
import AuditTest from "../pages/auditTest";

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<Acceuil />}
      />
      <Route
        path="/audit-test"
        element={<AuditTest />}
      />
      <Route
        path="/osint"
        element={<Osint />}
      />
      <Route
        path="/pentest"
        element={<Pentest />}
        path="/"
        element={<Acceuil />}
      />
      <Route
        path="/osint"
        element={<Osint />}
      />
      <Route
        path="/pentest"
        element={<Pentest />}
      />
      <Route
        path="/contact"
        element={<ContactPage />}
      />
      <Route
        path="/rdv"
        element={<RdvPage />}
      />
      <Route
        path="/resources"
        element={<ResourcesPage />}
      />
    </Routes>
  );
};

export default AppRoutes;
